package game.ui;

import cerastes.fmt.gltf.Util;
import game.scenes.RepairScene;
import h3d.Vector;
import data.Parts.PartDef;
import cerastes.ui.Timeline.TimelineRunner;
import cerastes.c3d.Vec3;
import h2d.Bitmap;
import h2d.Mask;
import cerastes.CMath;
import h2d.Flow;
import cerastes.SoundManager;
import cerastes.LocalizationManager;
import cerastes.Utils;
import hxd.Event;
import h2d.Interactive;
import cerastes.ui.Button;
import cerastes.fmt.CUIResource.CUIObject;
import cerastes.ui.UIEntity;
#if tools
import cerastes.tools.ImguiTool.ImGuiToolManager;
import imgui.ImGuiMacro.wref;
import imgui.ImGui;
import cerastes.tools.ImguiTools.IG;
#end

@:structInit class UIPartDef extends CUIObject
{
}

@:build(cerastes.macros.Callbacks.CallbackGenerator.build())
@:build(cerastes.macros.UIEntityBuilder.build( UIPartDef ))
class UIPart extends UIEntity
{

	@:obj public var intRoot: Interactive;
	@:obj public var bmpSprite: h2d.Bitmap;
	@:obj public var bmpLayer: h2d.Bitmap;
	@:obj public var txtDebug: h2d.Text;

	@:obj public var txtChip: h2d.Text;
	@:obj public var txtSnd: h2d.Text;

	public var part: PartDef;
	var container: h2d.Object;

	public var defective = false;
	var socket: UIPartSocket;

	public var generic = false;

	var r: TimelineRunner;

		@:callbackStatic
	public static function onPartDropped( );


	public override function initialize( root: h2d.Object )
	{
		cerastes.macros.UIPopulator.populateObjects();
		super.initialize(root);
		enableDrag();
	}

	public function setSocket( s: UIPartSocket )
	{
		if( socket != null )
			socket.onPartDetached();
		socket = s;
	}

	public function setDefective()
	{
		//bmpSprite.colorAdd = Vector.fromColor (0xFF0000);
		switch( part.type )
		{
			case 0: // Capacitor
				bmpSprite.tile = Utils.getTile("atlases/ui.catlas|capacitor_1damaged");
			default:
		}
		defective = true;
	}

	public function setGeneric()
	{
		generic = true;
		bmpLayer.visible = false;
		txtChip.visible = false;
		txtSnd.visible = false;
		//bmpSprite.color.setColor(0xFFFFFFFF);
		//txtDebug.text = '${LocalizationManager.localize( 'part_type_${part.type}' )}';

		//bmpSprite.colorAdd.setColor(0xFF0000);
	}

	public function setPart( p: PartDef )
	{
		if( p == null )
		{
			visible = false;
			return;

		}
		part = p;
		container = cast parent;

		//txtDebug.text = '${p.name}';
		var entry = null;
		bmpLayer.visible = false;
		switch( p.type )
		{
			case 0: // Capacitor
				txtChip.visible = false;
				txtSnd.visible = false;
				entry = Utils.getAtlasEntry("atlases/ui.catlas|capacitor_1");
				bmpLayer.tile = Utils.getTile("atlases/ui.catlas|capacitor1layer");
				bmpLayer.color.setColor( Std.parseInt( p.tint ) + 0xFF000000 );
				bmpLayer.visible = true;
			case 1: // Sound chip
				txtChip.visible = false;
				txtSnd.visible = true;
				entry = Utils.getAtlasEntry("atlases/ui.catlas|long_chip");
				txtSnd.text = LocalizationManager.localize( 'part_sound_${p.value}' );
			case 2: // Processor
				txtChip.visible = true;
				txtSnd.visible = false;
				entry = Utils.getAtlasEntry("atlases/ui.catlas|square_chip");
				txtChip.text = LocalizationManager.localize( 'part_proc_${p.value}' );
			default:
		}
		bmpSprite.tile = entry.tile;
		intRoot.width = entry.tile.width;
		intRoot.height = entry.tile.height;
	}


	public function enableTooltip( enabled: Bool )
	{
		if( enabled )
		{
			intRoot.onOver = onTooltip;
			intRoot.onOut = removeTooltip;
		}
		else
		{
			intRoot.onOver = null;

			removeTooltip(null);
		}
	}

	public function enableDrag()
	{
		registerDrag( intRoot, (e: Event) -> {
			#if js
			var baseX = 640;
			var baseY = 360;

			x = getScene().mouseX;
			y = getScene().mouseY;

			#else
			x = getScene().mouseX;
			y = getScene().mouseY;
			#end

			x -= intRoot.width / 2;
			y -= intRoot.height / 2;


			x = Math.floor(x);
			y = Math.floor(y);

			e.propagate = true;
		}, game.ui.UITypes.DragKey.Part );
	}

	var tt: h2d.Object;
	function onTooltip(e: hxd.Event)
	{
		/*
		removeTooltip(e);
		onPartHover(part, true);

		if( UIEntity.draggingEntity != null )
			return;

		tt = hxd.Res.ui.part_hover.toObject(this.getScene());
		var flowCards: h2d.Flow = cast tt.getObjectByName("flow_cards");

		flowCards.removeChildren();
		for( cid in part.data.cards)
		{
			var c = new Card(cid);
			var minicard: CardMiniUI = Std.downcast( hxd.Res.ui.card_mini.toObject( flowCards ), CardMiniUI );
			Utils.assert( minicard != null, "Card mini UI is broken" );

			minicard.setCard( c );
		}

		var b = getBounds();

		var ttb = tt.getBounds();

		tt.x = b.x - ttb.width - 10;
		if( tt.x < 0 )
			tt.x = b.x + b.width + 10;
		tt.y = b.y;

		var txt: h2d.Text = cast tt.getObjectByName("txt_part");
		txt.text = part.data.name;
		//SoundManager.playFile("sfx/TODO.wav");

*/
	}

	function removeTooltip(e: hxd.Event)
	{
		/*
		if( tt != null )
			tt.remove();
		tt = null;
		if( part != null )
			onPartHover(part, false);
		*/
	}

	public override function onRemove()
	{
		super.onRemove();
		removeTooltip(null);
	}



	public function setDragValid( v: Bool )
	{
		//bmpFrameHighlight.alpha = v ? 1 : 0;
	}

	var oldParent: h2d.Object;
	override function onDragStart(e: Event)
	{
		if( RepairScene.tool != Tweezers || RepairScene.isOn )
			return;
		
		//SoundManager.playFile("sfx/select.wav");
		super.onDragStart(e);
		oldParent = container;
		var newParent = oldParent.getScene();
		newParent.addChild(this);

		e.relX = hxd.Window.getInstance().mouseX;
		e.relY = hxd.Window.getInstance().mouseY;

		SoundManager.play("grab");

		dragCallback(e);

	}

	override function onDragEnd()
	{
		SoundManager.play("drop");
		untag();

		onPartDropped();

		UIEntity.draggingEntity = null;
		setDragValid(false);
		oldParent.addChild(this);

		super.onDragEnd();

	}

	public function reset()
	{
		container.addChild(this);
		untag();
	}

	public function tag()
	{
		if( r != null )
			r.stop();

		r = createTimelineRunner("tag");
		if( r != null )
			r.play();
	}

	public function untag()
	{
		if( r != null )
			r.stop();

		r = createTimelineRunner("untag");
		if( r != null )
			r.play();
	}



/*
	public override function getDragBounds()
	{
		var cb = getBounds();
		var mid = cb.getCenter();
		var b = new Bounds();
		b.addPoint( new h2d.col.Point( mid.x + intContainer.width / 2, mid.y + intContainer.height / 2   ) );
		b.addPoint( new h2d.col.Point( mid.x - intContainer.width / 2, mid.y - intContainer.height / 2   ) );

		return b;
	}


*/
}